import { NetworkStatus } from '@apollo/client';
import { useQuery } from 'data-fetching-client';
import Raven from 'raven-js';
import { useCallback } from 'react';
import { SELECT_TEAMS_QUERY } from '../queries/teams.queries';
export const useTeams = ({
  objectTypeId,
  routingSource,
  skipFetch,
  workspaceId
}) => {
  const {
    data,
    error,
    loading,
    networkStatus,
    refetch
  } = useQuery(SELECT_TEAMS_QUERY, {
    notifyOnNetworkStatusChange: true,
    onError: errorToTrack => {
      Raven.captureException(errorToTrack);
    },
    skip: skipFetch || !objectTypeId && !workspaceId,
    variables: {
      objectTypeId,
      routingSource,
      workspaceId
    }
  });
  const refetchTeams = useCallback(() => refetch({
    objectTypeId,
    routingSource,
    workspaceId
  }), [objectTypeId, routingSource, refetch, workspaceId]);
  return {
    error,
    loading,
    refetch: refetchTeams,
    refetching: networkStatus === NetworkStatus.refetch,
    teams: data === null || data === void 0 ? void 0 : data.teams
  };
};